import { DataUserMPFormType, SendDataUserMPType } from 'entities/users/types';

export const transformDataUserMP = ({
  selectedCountryCode,
  phone,
  first_name,
  middle_name,
  last_name,
  city_id,
  country_id,
  iin,
  source_id,
  role,
  document_number,
  personal_number,
  issued_at,
  expiration_at,
}: DataUserMPFormType): SendDataUserMPType => {
  const createDocumentData =
    country_id === 3 || country_id === 4 ? { document_number, personal_number, issued_at, expiration_at } : null;

  return {
    phone: `${selectedCountryCode}${phone}`,
    first_name,
    middle_name,
    last_name,
    city_id,
    country_id,
    iin: iin?.length === 0 ? null : iin,
    source_id,
    role,
    password: '',
    document: createDocumentData,
  };
};
